import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { User } from 'src/app/model/User';
import { EmployeeService } from 'src/app/services/employee.service';
import { LoaderService } from 'src/app/services/loader.service';
const moment: any = (_moment as any).default || _moment;

@Component({
  selector: 'app-employee-exit',
  templateUrl: './employee-exit.component.html',
  styleUrls: ['./employee-exit.component.css'],
})
export class EmployeeExitComponent implements OnInit {
  nishContractId: number;
  successFlag: Boolean = false;
  errorFlag: Boolean = false;
  errorDescription: any;
  user: User;
  loading$: any;
  davChecked: boolean = false;
  simChecked: boolean = false;
  filterEmpName: string;
  empName: any = undefined;

  assetList: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    public employService: EmployeeService,
    public loader: LoaderService,
  ) {}

  ngOnInit(): void {}

  dateOfJoiningFilter = (m: Moment | null): boolean => {
    const day = (m || moment()).day();
    return day !== 0 && day !== 6;
  };

  empNameSelected(emp: any) {
    this.empName = emp;
    let employeeId: any = '';
    if (!emp) {
      employeeId = '';
    } else if (typeof emp === 'string') {
      employeeId = emp;
    } else if (emp.empId) {
      employeeId = emp.empId;
    } else if (emp.empBasicInfo && emp.empBasicInfo.empId) {
      employeeId = emp.empBasicInfo.empId;
    }
    // call search with a synthetic event shape expected by searchEmployeeId
    this.searchEmployeeId({
      target: { value: employeeId },
    } as unknown as Event);
  }

  searchEmployeeId($event: Event) {
    this.successFlag = false;
    const employeeId = ($event.target as HTMLTextAreaElement).value;

    if (employeeId != '') {
      const empId = employeeId.split('-')[0].trim();
      this.employService.getEmployeeExitDetails(empId).subscribe((res) => {
        console.log(res);
        this.empExitForm.patchValue({
          employeeId: res.employeeId,
          onboardingStatus: res.onboardingStatus,
          noticeType: res.noticeType,
          endOfContract: res.endOfContract,
          sim: res.sim,
          dav: res.dav,
          comments: res.comments,
        });
        if (res.noticeStartDate != null) {
          this.empExitForm.patchValue({
            noticeStartDate: this.parseLocalDate(res.noticeStartDate),
          });
        }
        if (res.noticeLastDate != null) {
          this.empExitForm.patchValue({
            noticeLastDate: this.parseLocalDate(res.noticeLastDate),
          });
        }
        this.assetList = res.assetDetails;
      });
    }
  }

  private parseLocalDate(value: any): Moment | null {
    if (!value) {
      return null;
    }

    if (moment.isMoment(value)) {
      return value.clone();
    }

    if (value instanceof Date) {
      return moment.utc(value).startOf('day');
    }

    if (Array.isArray(value) && value.length >= 3) {
      const year = Number(value[0]);
      const month = Number(value[1]) - 1;
      const day = Number(value[2]);
      return moment.utc([year, month, day]);
    }

    const stringValue = String(value || '');
    const isoMatch = stringValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const year = Number(isoMatch[1]);
      const month = Number(isoMatch[2]) - 1;
      const day = Number(isoMatch[3]);
      return moment.utc([year, month, day]);
    }

    const parsed = moment.utc(value);
    if (parsed.isValid()) {
      return parsed.startOf('day');
    }

    return null;
  }

  onSubmit() {
    if (
      this.empExitForm.invalid ||
      !this.empExitForm.get('noticeType')?.value ||
      !this.empExitForm.get('endOfContract')?.value ||
      this.assetList.length > 0
    ) {
      return;
    }

    this.errorFlag = false;
    this.successFlag = false;

    this.user = JSON.parse(localStorage.getItem('userDetails') || '{}') as User;
    const body = JSON.stringify(this.empExitForm.getRawValue());

    console.log('leaves jason' + body);

    this.employService.updateEmployeeExit(body).subscribe((data) => {
      console.log('data ==========> ' + data);

      if (data.status == 'Failure') {
        this.errorFlag = true;
        this.errorDescription = data.errorDescription;
      } else {
        this.successFlag = true;
        this.empExitForm.reset();
        this.assetList = [];
      }
    });
  }

  empExitForm = this.fb.group({
    employeeId: ['', Validators.required],
    onboardingStatus: ['', Validators.required],
    noticeStartDate: [null, Validators.required],
    noticeLastDate: [null, Validators.required],
    noticeType: [null, Validators.required],
    endOfContract: [null, Validators.required],
    comments: [''],
    sim: [''],
    dav: [''],
    updatedBy: [''],
  });
}
